import auth from '@/api/edge/auth'
import authMisc from '@/api/edge/authMisc'

export default {
  auth,
  authMisc,
}
